"use client"

import Link from "next/link";
import { useState } from "react";
import styles from "../../styles/Pages/RidesAndActivities.module.scss";
import { StoresData } from "../../data/storesData";
import { RxCross2 } from 'react-icons/rx';
import Topbanner from "../../components/Reusable/Banner/Topbanner";
// import {StoresData} from "../../data/storesData";

// export const getStaticProps = async () => {
//   return {
//     props: {
//       Allstores: StoresData,
//     },
//   };
// };

export default function Stores() {
    const Allstores = StoresData;
  const [modal, setModal] = useState(false);
  const openModal = (value) => {
    setModal(value);
  };

  return (
    <>
      <Topbanner
        title={"Our Ultimate stores"}
        bgImage={"/images/stores-banner.png"}
        target="#firstsec"
      />
      <section className={`${styles.all_stores} common_padding pb-0`} id='firstsec'>
        <div className="container">
          <div className="row">
            {Allstores.map((store, index) => (
              <div
                className={`${styles.store_child} common_title col-md-3`}
                key={store.slug}
              >
                <img src={store.bgImage} alt={store.title} />
                <h3>{store.title}</h3>
                <p>{store.description}</p>
                {/* <Link className="secoundary_btn" href='/'>Show Info</Link> */}
                <button className="secoundary_btn" onClick={() => openModal(index)}>Store Info</button>
                {modal === index ? (
                  <div className={styles.popup_bg}>
                    <div className={styles.popup_align}>
                      <div className={styles.popup_content}>
                        <div className={styles.top_sec}>
                          <h3>{store.title}</h3>
                          <button onClick={openModal}><RxCross2 /></button>
                        </div>
                        <div className={styles.bottom_sec}>
                          <h3><strong>Phone</strong></h3>
                          <Link href={`tel:${store.phone_number}`}><span>+91 </span>{store.phone_number}</Link>
                          <h3><strong>Email</strong></h3>
                          <Link href={`mailto:${store.email_address}`}>{store.email_address}</Link>
                          <h3><strong>Operating Hours</strong></h3>
                          <p>{store.trading_hours}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : ''}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
